export type BenchmarkEmptyStateType = 'historical' | 'peer';

export interface BenchmarkEmptyStateParams {
  hasTenantHistory: boolean;
  hasTenantData?: boolean;
  hasPeerData: boolean;
}

export function resolveBenchmarkEmptyStateType({
  hasTenantHistory,
  hasTenantData = true,
  hasPeerData,
}: BenchmarkEmptyStateParams): BenchmarkEmptyStateType | null {
  if (!hasTenantData || !hasTenantHistory) {
    return 'historical';
  }
  return hasPeerData ? null : 'peer';
}
